// extracted by mini-css-extract-plugin
export default {"default":"CustomButton_default__xG7EB","primary":"CustomButton_primary__PghAg","outline_primary":"CustomButton_outline_primary__PvR4d"};